import { create } from 'zustand';

interface AppState {
  isAuditRunning: boolean;
  setIsAuditRunning: (isRunning: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  isAuditRunning: false,
  setIsAuditRunning: (isRunning) => set({ isAuditRunning: isRunning }),
}));